<template>
  <div id="catalogoArea" class="contenedor">
    <Sidebar></Sidebar>
    <loader :show="show" />
    <v-container
      fluid
      class="base text-center ma-0 px-0 pt-6 pb-0"
      v-if="catalogo"
    >
      <v-row no-gutters class="titulo catalogoTitle"
        >Días de vacaciones por años</v-row
      >

      <v-row class="catalogo catalogoList">
        <v-col cols="12" sm="8" class="py-3">Empresa Pagadora</v-col>
        <v-col cols="12" sm="4" class="py-3 selectGris">
          <select
            name="pagadora"
            id="pagadora"
            v-model="enterprise"
            @change="consultaVacaciones()"
          >
            <option disabled value="0">Selecciona</option>
            <option
              v-for="enterprise in enterprises"
              :key="enterprise.id"
              v-bind:value="enterprise.id"
            >
              {{ enterprise.razonSocial }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-3">Año 0</v-col>
        <v-col cols="12" sm="4" class="py-3 selectGris">
          <select
            name="a0"
            id="a0"
            v-model="a0"
            style="width: 80px !important"
            class="mr-2"
          >
            <option selected disabled value="0">Seleccione</option>
            <option v-for="day in days" :key="day.id" v-bind:value="day.id">
              {{ day.name }}
            </option></select
          >días
        </v-col>
        <v-col cols="12" sm="8" class="py-3">Año 1</v-col>
        <v-col cols="12" sm="4" class="py-3 selectGris">
          <select
            name="a1"
            id="a1"
            v-model="a1"
            style="width: 80px !important"
            class="mr-2"
          >
            <option selected disabled value="0">Seleccione</option>
            <option v-for="day in days" :key="day.id" v-bind:value="day.id">
              {{ day.name }}
            </option></select
          >días
        </v-col>
        <v-col cols="12" sm="8" class="py-3">Año 2</v-col>
        <v-col cols="12" sm="4" class="py-3 selectGris">
          <select
            name="a2"
            id="a2"
            v-model="a2"
            style="width: 80px !important"
            class="mr-2"
          >
            <option selected disabled value="0">Seleccione</option>
            <option v-for="day in days" :key="day.id" v-bind:value="day.id">
              {{ day.name }}
            </option></select
          >días
        </v-col>
        <v-col cols="12" sm="8" class="py-3">Año 3</v-col>
        <v-col cols="12" sm="4" class="py-3 selectGris">
          <select
            name="a3"
            id="a3"
            v-model="a3"
            style="width: 80px !important"
            class="mr-2"
          >
            <option selected disabled value="0">Seleccione</option>
            <option v-for="day in days" :key="day.id" v-bind:value="day.id">
              {{ day.name }}
            </option></select
          >días
        </v-col>
        <v-col cols="12" sm="8" class="py-3">Año 4</v-col>
        <v-col cols="12" sm="4" class="py-3 selectGris">
          <select
            name="a4"
            id="a4"
            v-model="a4"
            style="width: 80px !important"
            class="mr-2"
          >
            <option selected disabled value="0">Seleccione</option>
            <option v-for="day in days" :key="day.id" v-bind:value="day.id">
              {{ day.name }}
            </option></select
          >días
        </v-col>
        <v-col cols="12" sm="8" class="py-3">Año 5</v-col>
        <v-col cols="12" sm="4" class="py-3 selectGris">
          <select
            name="a5"
            id="a5"
            v-model="a5"
            style="width: 80px !important"
            class="mr-2"
          >
            <option selected disabled value="0">Seleccione</option>
            <option v-for="day in days" :key="day.id" v-bind:value="day.id">
              {{ day.name }}
            </option></select
          >días
        </v-col>
        <v-col cols="12" sm="8" class="py-3">Año 10</v-col>
        <v-col cols="12" sm="4" class="py-3 selectGris">
          <select
            name="a10"
            id="a10"
            v-model="a10"
            style="width: 80px !important"
            class="mr-2"
          >
            <option selected disabled value="0">Seleccione</option>
            <option v-for="day in days" :key="day.id" v-bind:value="day.id">
              {{ day.name }}
            </option></select
          >días
        </v-col>
        <v-col cols="12" sm="8" class="py-3">Año 15</v-col>
        <v-col cols="12" sm="4" class="py-3 selectGris">
          <select
            name="a15"
            id="a15"
            v-model="a15"
            style="width: 80px !important"
            class="mr-2"
          >
            <option selected disabled value="0">Seleccione</option>
            <option v-for="day in days" :key="day.id" v-bind:value="day.id">
              {{ day.name }}
            </option></select
          >días
        </v-col>
        <v-col cols="12" sm="8" class="py-3">Año 20</v-col>
        <v-col cols="12" sm="4" class="py-3 selectGris">
          <select
            name="a20"
            id="a20"
            v-model="a20"
            style="width: 80px !important"
            class="mr-2"
          >
            <option selected disabled value="0">Seleccione</option>
            <option v-for="day in days" :key="day.id" v-bind:value="day.id">
              {{ day.name }}
            </option></select
          >días
        </v-col>
        <v-col cols="12" sm="8" class="py-3">Año 25</v-col>
        <v-col cols="12" sm="4" class="py-3 selectGris">
          <select
            name="a25"
            id="a25"
            v-model="a25"
            style="width: 80px !important"
            class="mr-2"
          >
            <option selected disabled value="0">Seleccione</option>
            <option v-for="day in days" :key="day.id" v-bind:value="day.id">
              {{ day.name }}
            </option></select
          >días
        </v-col>
        <v-col cols="12" sm="8" class="py-3">Año 30</v-col>
        <v-col cols="12" sm="4" class="py-3 selectGris">
          <select
            name="a30"
            id="a30"
            v-model="a30"
            style="width: 80px !important"
            class="mr-2"
          >
            <option selected disabled value="0">Seleccione</option>
            <option v-for="day in days" :key="day.id" v-bind:value="day.id">
              {{ day.name }}
            </option></select
          >días
        </v-col>
        <v-col cols="12" sm="8" class="py-3">Año 35</v-col>
        <v-col cols="12" sm="4" class="py-3 selectGris">
          <select
            name="a35"
            id="a35"
            v-model="a35"
            style="width: 80px !important"
            class="mr-2"
          >
            <option selected disabled value="0">Seleccione</option>
            <option v-for="day in days" :key="day.id" v-bind:value="day.id">
              {{ day.name }}
            </option></select
          >días
        </v-col>
        <v-col cols="12" sm="12" class="mt-3 pa-0" align-self="end">
          <button class="boton" @click="validacion()">Siguiente</button>
        </v-col>
      </v-row>
    </v-container>
    <!--Error-->
    <v-dialog v-model="error" width="530">
      <v-card>
        <v-card-title class="red white--text">
          <span class="headline">{{ message }}</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-md-center text-sm-center text-lg-center">
            {{ respuesta }}
          </h3>
          <br />
          <ul>
            <li v-for="error in errors" :key="error.name">{{ error }}</li>
          </ul>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="warning" text @click="error = false">Corregir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Validación de datos-->
    <v-dialog v-model="advice" width="400">
      <v-card>
        <v-card-title class="orange white--text">
          <span class="headline">{{ message }}</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-md-center text-lg-center text-sm-center">
            {{ respuesta }}
          </h3>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="red" text @click="cancelar()">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="guardar()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Confirmación de datos-->
    <v-dialog v-model="confirmation" width="400">
      <v-card>
        <v-card-title class="orange white--text">
          <span class="headline">{{ message }}</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-lg-center text-sm-center text-md-center">
            {{ respuesta }}
          </h3>
          <br />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="auxiliar()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Sidebar from "@/components/Sidebar.vue";
import Loader from "@/components/Loader";
export default {
  components: {
    Sidebar,
    Loader,
  },
  data() {
    return {
      show: false,
      stepn: "7-N",
      error: false,
      errors: [],
      respuesta: "",
      titulo: "",
      catalogo: true,
      lista: false,
      enterprise: 0,
      enterprises: [],
      advice: false,
      confirmation: false,
      days: [],
      message: "",
      a0: 0,
      a1: 0,
      a2: 0,
      a3: 0,
      a4: 0,
      a5: 0,
      a10: 0,
      a15: 0,
      a20: 0,
      a25: 0,
      a30: 0,
      a35: 0,
      nuevoRegistro: true,
      id: 0,
    };
  },
  methods: {
    nombre() {
      localStorage.stepn = this.stepn;
    },
    validacion() {
      this.errors = [];
      this.message = "Días de vaciones";
      if (this.enterprise == 0 || this.enterprise == "") {
        this.errors.push("Se debe especificar la empresa.");
      }
      if (this.a0 == 0) {
        this.errors.push(
          "Se debe especificar el número de días para la antigüedad de 0 años."
        );
      }
      if (this.a1 == 0) {
        this.errors.push(
          "Se debe especificar el número de días para la antigüedad de 1 años."
        );
      }
      if (this.a2 == 0) {
        this.errors.push(
          "Se debe especificar el número de días para la antigüedad de 2 años."
        );
      }
      if (this.a3 == 0) {
        this.errors.push(
          "Se debe especificar el número de días para la antigüedad de 3 años."
        );
      }
      if (this.a4 == 0) {
        this.errors.push(
          "Se debe especificar el número de días para la antigüedad de 4 años."
        );
      }
      if (this.a5 == 0) {
        this.errors.push(
          "Se debe especificar el número de días para la antigüedad de 5 años."
        );
      }
      if (this.a10 == 0) {
        this.errors.push(
          "Se debe especificar el número de días para la antigüedad de 10 años."
        );
      }
      if (this.a15 == 0) {
        this.errors.push(
          "Se debe especificar el número de días para la antigüedad de 15 años."
        );
      }
      if (this.a20 == 0) {
        this.errors.push(
          "Se debe especificar el número de días para la antigüedad de 20 años."
        );
      }
      if (this.a25 == 0) {
        this.errors.push(
          "Se debe especificar el número de días para la antigüedad de 25 años."
        );
      }
      if (this.a30 == 0) {
        this.errors.push(
          "Se debe especificar el número de días para la antigüedad de 30 años."
        );
      }
      if (this.a35 == 0) {
        this.errors.push(
          "Se debe especificar el número de días para la antigüedad de 35 años."
        );
      }
      if (this.errors.length == 0) {
        this.respuesta = "Esta seguro de la almecenar los días de vacaciones.";
        this.advice = true;
      } else {
        this.respuesta = "Por favor corrige el siguiente error:";
        this.error = true;
      }
    },
    cancelar() {
      this.a0 = 0;
      this.a1 = 0;
      this.a2 = 0;
      this.a3 = 0;
      this.a4 = 0;
      this.a5 = 0;
      this.a6 = 0;
      this.a7 = 0;
      this.a8 = 0;
      this.a9 = 0;
      this.a10 = 0;
      this.a15 = 0;
      this.a20 = 0;
      this.a25 = 0;
      this.a30 = 0;
      this.a35 = 0;
      this.advice = false;
    },
    consultaVacaciones() {
      this.a0 = 0;
      this.a1 = 0;
      this.a2 = 0;
      this.a3 = 0;
      this.a4 = 0;
      this.a5 = 0;
      this.a10 = 0;
      this.a15 = 0;
      this.a20 = 0;
      this.a25 = 0;
      this.a30 = 0;
      this.a35 = 0;
      this.show = true;
      axios
        .get(Server + "/vacacionesAnio/empresa/" + this.enterprise)
        .then((response) => {
          this.show = false;
          var aux = response.data;
          if (aux.length > 0) {
            this.nuevoRegistro = false;
            (this.id = aux[0].id), (this.a0 = aux[0].anioCero);
            this.a1 = aux[0].anioUno;
            this.a2 = aux[0].anioDos;
            this.a3 = aux[0].anioTres;
            this.a4 = aux[0].anioCuatro;
            this.a5 = aux[0].anioCinco;
            this.a10 = aux[0].anioDiez;
            this.a15 = aux[0].anioQuince;
            this.a20 = aux[0].anioVeinte;
            this.a25 = aux[0].anioVeinticinco;
            this.a30 = aux[0].anioTreinta;
            this.a35 = aux[0].anioTreintaicinco;
          }
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
        });
    },
    listar() {
      this.show = true;
      axios
        .get(Server + "/empresas")
        .then((response) => {
          this.enterprises = response.data;
          this.show = false;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
        });
    },

    guardar() {
      this.advice = false;
      if (this.nuevoRegistro) {
        this.show = true;
        axios
          .post(Server + "/vacacionesAnio", {
            AnioCero: this.a0,
            AnioUno: this.a1,
            AnioDos: this.a2,
            AnioTres: this.a3,
            AnioCuatro: this.a4,
            AnioCinco: this.a5,
            AnioDiez: this.a10,
            AnioQuince: this.a15,
            AnioVeinte: this.a20,
            AnioVeinticinco: this.a25,
            AnioTreinta: this.a30,
            AnioTreintaicinco: this.a35,
            EmpresaId: this.enterprise,
          })
          .then((response) => {
            this.show = false;
            this.a0 = 0;
            this.a1 = 0;
            this.a2 = 0;
            this.a3 = 0;
            this.a4 = 0;
            this.a5 = 0;
            this.a10 = 0;
            this.a15 = 0;
            this.a20 = 0;
            this.a25 = 0;
            this.a30 = 0;
            this.a35 = 0;
            this.nuevoRegistro = true;
            this.enterprise = 0;
            this.message = "Confirmación";
            this.respuesta = "Los días fueron almacenados con éxito";
            this.confirmation = true;
          })
          .catch((e) => {
            this.show = false;
            this.a0 = 0;
            this.a1 = 0;
            this.a2 = 0;
            this.a3 = 0;
            this.a4 = 0;
            this.a5 = 0;
            this.a10 = 0;
            this.a15 = 0;
            this.a20 = 0;
            this.a25 = 0;
            this.a30 = 0;
            this.a35 = 0;
            this.enterprise = 0;
            this.message = "AVISO";
            this.nuevoRegistro = true;
            this.respuesta = "Los días no fueron almacenados con éxito";
            this.confirmation = true;
          });
      } else {
        this.show = true;
        axios
          .put(Server + "/vacacionesAnio/" + this.id, {
            Id: this.id,
            AnioCero: this.a0,
            AnioUno: this.a1,
            AnioDos: this.a2,
            AnioTres: this.a3,
            AnioCuatro: this.a4,
            AnioCinco: this.a5,
            AnioDiez: this.a10,
            AnioQuince: this.a15,
            AnioVeinte: this.a20,
            AnioVeinticinco: this.a25,
            AnioTreinta: this.a30,
            AnioTreintaicinco: this.a35,
            EmpresaId: this.enterprise,
          })
          .then((response) => {
            this.show = false;
            this.a0 = 0;
            this.a1 = 0;
            this.a2 = 0;
            this.a3 = 0;
            this.a4 = 0;
            this.a5 = 0;
            this.a10 = 0;
            this.a15 = 0;
            this.a20 = 0;
            this.a25 = 0;
            this.a30 = 0;
            this.a35 = 0;
            this.enterprise = 0;
            this.nuevoRegistro = true;
            this.message = "Confirmación";
            this.respuesta = "Los días fueron actualizados con éxito";
            this.confirmation = true;
          })
          .catch((e) => {
            this.show = false;
            this.a0 = 0;
            this.a1 = 0;
            this.a2 = 0;
            this.a3 = 0;
            this.a4 = 0;
            this.a5 = 0;
            this.a10 = 0;
            this.a15 = 0;
            this.a20 = 0;
            this.a25 = 0;
            this.a30 = 0;
            this.a35 = 0;
            this.message = "AVISO";
            this.nuevoRegistro = true;
            this.enterprise = 0;
            this.respuesta = "Los días no fueron actualizados con éxito";
            this.confirmation = true;
          });
      }
    },

    auxiliar() {
      this.$router.push("/calendar");
    },
  },
  created() {
    this.nombre();
    for (let index = 1; index <= 60; index++) {
      this.days.push({
        id: index,
        name: index.toString(),
      });
    }
    this.listar();
  },
};
</script>